import React from 'react';
import { PropTypes } from 'prop-types';

class AddRemoveButton extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      deleting: false
    }
  }
  render() {
    const { canAddProviders, assigned, onClick } = this.props;
    const disabled = (assigned === 'N' && !canAddProviders) || this.props.disabled

    const { deletionReason } = this.state;
    if(this.state.deleting){
      const deleteFn = () => {
        if(deletionReason && deletionReason.length > 0){
          this.setState({deleting: false}, () =>{
            onClick(deletionReason);
            this.setState({deletionReason: undefined}); //clear the text box after submitting
          });
        }
      }
      return (
        <div>
          <input
            type='text'
            placeholder='Removal Reason'
            defaultValue={deletionReason}
            onChange={ (ev) => this.setState({deletionReason: ev.target.value}) }/>
          <div className='button' onClick={deleteFn}>Remove</div>
        </div>
      )

    }else{
      let text = '+ Add';
      if (assigned === 'Y') {
        text = '- Remove';
      }

      const fn = () => {
        if (!disabled) {
          if(assigned === 'N'){
            onClick();
          }else{
            this.setState({deleting: true});
          }
        }
      };

      let className = 'button';
      if (disabled) {
        className += ' disabled';
      }
      
      return (
        <div className={className} onClick={fn}>{text}</div>
      );
    }
  }
};

AddRemoveButton.propTypes = {
  canAddProviders: PropTypes.bool,
  disabled:        PropTypes.bool,
  assigned:        PropTypes.string,
  onClick:         PropTypes.func
};

class ProviderSearchTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows:    [],
      loading: false
    };
  }

  componentDidMount() {
    const { store } = this.context;
    this.subscription = store.subscribe(() => {
      const providersStore = store.getState().providerIncentiveCost.providers;
      this.setState({ loading: providersStore.togglingProvider, rows: providersStore.items });
    });
  }

  componentWillUnmount() {
    this.subscription();
  }

  addOrRemoveProvider(provider, deletionReason) {
    const { removeProviderFromIncentive, addProviderToIncentive } = this.context;
    const { incentiveCost: { provider_incentive_cost_id } } = this.props;
    if (provider.assigned === 'N') {
      addProviderToIncentive(provider_incentive_cost_id, provider.id);
    } else {
      removeProviderFromIncentive(provider_incentive_cost_id, provider.id, deletionReason);
    }
  }
  render() {
    const { canAddProviders } = this.props;
    const { rows, loading } = this.state;
    return (
      <table>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          { rows.map(provider => (
            <tr key={provider.id}>
              <td>{provider.first_name}</td>
              <td>{provider.last_name}</td>
              <td>
                <AddRemoveButton
                  canAddProviders={canAddProviders}
                  disabled={loading}
                  onClick={(deletionReason) => this.addOrRemoveProvider(provider, deletionReason)}
                  assigned={provider.assigned}
                />
              </td>
            </tr>
            ))
          }
        </tbody>
      </table>
    );
  }
}

ProviderSearchTable.propTypes = {
  canAddProviders: PropTypes.bool,
  incentiveCost:   PropTypes.shape({ provider_incentive_cost_id: PropTypes.number })
};

ProviderSearchTable.contextTypes = {
  addProviderToIncentive:      PropTypes.func,
  removeProviderFromIncentive: PropTypes.func,
  store:                       PropTypes.object
};

export default ProviderSearchTable;
